export enum PaymentMethodEnum {
  Raiffeisen = 1,
  Stripe = 2,
  Transfer = 3,
  NLB = 7
}
export enum TicketStatusEnum {
  Confirmed = 1,
  Pending = 2,
  Canceled = 3,
  Refund = 4
}

// A ticket can be cancelled on its own while the booking around it stays confirmed.
export const isTicketCanceled = (statusId?: number): boolean =>
  statusId === TicketStatusEnum.Canceled || statusId === TicketStatusEnum.Refund;

// What to call a ticket that is no longer valid; null while the ticket still holds.
export const ticketStatusLabel = (statusId?: number): string | null => {
  if (statusId === TicketStatusEnum.Canceled) return "E anuluar";
  if (statusId === TicketStatusEnum.Refund) return "E rimbursuar";
  return null;
};
